import clsx from 'clsx'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import ModelCategory from 'model/screens/breakdown/ModelCategory'
import { useTranslation } from 'react-i18next'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { Alert } from '@mui/material'

export default function ModelCategories({ aid, onClose }) {
	const { t } = useTranslation(['common', 'model'])

	// #### REDUX
	const globalCategories = useSelector((state) => state.team.teamCategories?.result)

	// #### STATE
	const [isOpen, setIsOpen] = useState('new')

	function onDelete() {
		setIsOpen('new')
	}

	return (
		<>
			<Alert className="py-0 text-xs mb-4 " classes={{ message: 'flex flex-row items-center' }} severity="info">
				{t('model:categories.help')}
			</Alert>

			<div className="flex flex-row">
				<div className="flex-1 shrink-0 mr-2">
					{globalCategories &&
						Object.entries(globalCategories)?.map((entry, index) => {
							const isCatOpen = isOpen === entry[0]
							return (
								<div
									key={`catList#${index}`}
									className={clsx('flex flex-row justify-between items-center px-4 bg-bgGray rounded cursor-pointer hover:bg-borderGray mb-3', isCatOpen && 'bg-borderGray')}
									onClick={() => setIsOpen(entry[0])}
								>
									<div className={clsx('text-sm py-2 truncate', isCatOpen && 'font-medium')}>{entry[1]?.name}</div>
									{isCatOpen && <ChevronRightIcon fontSize="small" className="text-textGray" />}
								</div>
							)
						})}

					<div
						className={clsx('flex flex-row justify-between items-center px-4 bg-bgGray rounded cursor-pointer hover:bg-borderGray', isOpen === 'new' && 'bg-borderGray')}
						onClick={() => setIsOpen('new')}
					>
						<div className={clsx('text-sm py-2', isOpen === 'new' && 'font-medium')}>{t('model:categories.new')}</div>
						{isOpen === 'new' && <ChevronRightIcon fontSize="small" className="text-textGray" />}
					</div>
				</div>

				<div className="ml-2 flex-1 shrink-0 border-l border-borderGray pl-4">
					<ModelCategory catKey={isOpen} aid={aid} onDelete={onDelete} />
				</div>
			</div>
		</>
	)
}
